import moduleConfig from "./theme.config";

export default [
  {
    path: moduleConfig.basePath,
    component: () => import("./theme.module"),
    children: [],
  },
];
